import { render, staticRenderFns } from "./FeedProductSimproJobsTab.vue?vue&type=template&id=6dab36c1&"
import script from "./FeedProductSimproJobsTab.vue?vue&type=script&lang=ts&"
export * from "./FeedProductSimproJobsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports